import Modal from 'react-bootstrap/Modal';
import React, { useState,useEffect } from 'react';
import {MDBTable, MDBTableHead, MDBTableBody, MDBBtn } from 'mdb-react-ui-kit';
import { BiSkipPrevious, BiSkipNext  } from "react-icons/bi";


function ModalLog(props) {
  const [currentlog, setCurrentLog] = useState(1);
  const downlogdata = props.downloadlog;
  const uploaddate = props.upload_date;
  const filter =  downlogdata.filter((item) => item.upload_date ===  uploaddate)

  const logPerPage = 5;
  const totalLogs = Math.ceil(filter ? filter.length / logPerPage : "");
//  console.log(Math.ceil(filter.length / logPerPage));
 // console.log(totalLogs)
  const currentlogRows = filter ? filter.slice((currentlog - 1) * logPerPage, currentlog * logPerPage) :"";

//console.log(currentlogRows)

  const changeLog = (page) => {
    setCurrentLog(page);
  };

  const renderPaginationLinkslog = () => {
    const pageLinks = [];

    // Previous Button
    if (currentlog > 1) {
        pageLinks.push(
            <MDBBtn key="prev" onClick={() => changeLog(currentlog - 1)}><BiSkipPrevious style={{fontSize: "20px"}}  /></MDBBtn>
        );
    }

    // Page Numbers
    const maxPagesToShow = 5; // Adjust this value based on your preference
    const startPage = Math.max(1, currentlog - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalLogs, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
        pageLinks.push(
            <MDBBtn key={i} onClick={() => changeLog(i)}>{i}</MDBBtn>
        );
    }

    // // Ellipsis
    // if (currentlog < totalLogs - Math.floor(maxPagesToShow / 2)) {
    //     pageLinks.push(
    //         <span key="ellipsis" className="ellipsis">...</span>
    //     );
    // }

    // Next Button
    if (currentlog < totalLogs) {
        pageLinks.push(
            <MDBBtn key="next" onClick={() => changeLog(currentlog + 1)}><BiSkipNext style={{fontSize: "20px"}}  /></MDBBtn>
        );
    }

    return pageLinks;
};

//   console.log(downlogdata)
//   console.log(uploaddate)
//   console.log(filter)
//   console.log(props.Selected)

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      key={props.Selected}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" style={{fontSize:"16px"}}>
          Download Logs For {uploaddate}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MDBTable>
            <MDBTableHead>
            <tr>
                <th>User</th>
                <th>Date of Download</th>
                <th>Download item</th>
            </tr>
            </MDBTableHead>
            <MDBTableBody style={{maxHeight:"400px", overflowY: "scroll"}}>
            {currentlogRows ? currentlogRows.map((row, index) => (
                <tr key={index}>
                <td>{row.download_user}</td>
                <td>{row.download_date}</td>
                <td>{row.download_item}</td>
            </tr>
            )): "Loading"}
                        </MDBTableBody>
                        </MDBTable>
         <div className="pagination"> 
           {renderPaginationLinkslog()}

            {/* {Array.from({ length: totalLogs }, (_, index) => (
              <MDBBtn style={{marginTop:"15px", paddingLeft:"5px",marginRight:"5px"}} key={index + 1} onClick={() => changeLog(index + 1)}>
                {index + 1} 
              </MDBBtn>
            ))} */}
          </div>

        
      </Modal.Body>
      <Modal.Footer>
        <button className="ripple ripple-surface ripple-surface-light  btn-primary" onClick={props.onHide}>Close</button>
      </Modal.Footer>
    </Modal>
  );
}



export default ModalLog